import { useFetchEmployeesCount, useFetchLastBusinessCurrentPlanMaxEmployees } from '@expane/data'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Meter } from 'ui/Meter'

export const CurrentRestrictions: FC = () => {
  const { data: maxEmployees } = useFetchLastBusinessCurrentPlanMaxEmployees()

  return (
    <div className="mb-2">
      <MaxEmployeeMeter maxEmployees={maxEmployees} />
    </div>
  )
}

interface MeterProps {
  maxEmployees: number | undefined | null
}

const MaxEmployeeMeter: FC<MeterProps> = ({ maxEmployees }) => {
  const { t } = useTranslation()

  const { data: employeesCount } = useFetchEmployeesCount()

  return maxEmployees && maxEmployees > 1 ? (
    <Meter
      label={`${t('currentNumberOfEmployees')}: ${employeesCount}`}
      value={employeesCount ?? 0}
      max={maxEmployees}
    />
  ) : null
}
